/* Component Dependencies */
var keyAmenitiesTemplate = require('templates/keyAmenities.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'keyAmenities',
  template: {
    'keyAmenities': keyAmenitiesTemplate
  },
  bindEvents: function($) {
    var _self = this;

    $(window).on('load resize', function() {
      _self.toggleMinWidthClass();
    });
  },
  toggleMinWidthClass: function() {
    var _self = this,
      buttons = _self.$el.find('.m-button'),
      buttonContainer = _self.$el.find('ul + div');

    if ($(window).width() < 600) {
      buttons.addClass('btn-custom-style l-display-block');
      buttonContainer.addClass('l-width-max');
    } else {
      buttons.removeClass('btn-custom-style l-display-block');
      buttonContainer.removeClass('l-width-max');
    }
  }
});